import React from 'react';
import { FiMapPin, FiClock, FiTrendingUp } from 'react-icons/fi';
import { formatCurrency } from '../../utils/formatCurrency';
import './RentalPackageCard.css';

const RentalPackageCard = ({ pkg, onSelect, selected = false }) => {
  if (!pkg) return null;
  const {
    vehicle_type,
    package_name,
    package_type,
    trip_type,
    pricing_basis,
    places = [],
    package_price,
    included_km,
    included_hours,
    extra_km_price,
    extra_hour_price,
    description,
    status = true,
  } = pkg;

  return (
    <div className={`rpc-card ${!status ? 'unavailable' : ''} ${selected ? 'selected' : ''}`}>
      <div className="rpc-head">
        <div>
          <h4 className="rpc-type">{package_name || vehicle_type}</h4>
          {package_name && <p className="rpc-vehicle">{vehicle_type}</p>}
          <div className="rpc-tags">
            {package_type && <span>{package_type}</span>}
            {trip_type && <span>{trip_type.replace('_', ' ')}</span>}
            {pricing_basis && <span>Price per {pricing_basis}</span>}
          </div>
          {description && <p className="rpc-desc">{description}</p>}
        </div>
        <div className="rpc-price">
          <span>{formatCurrency(package_price)}</span>
          <small>starting</small>
        </div>
      </div>

      {places.length > 0 && (
        <p className="rpc-route"><FiMapPin /> {places.join(' → ')}</p>
      )}

      <div className="rpc-details">
        {included_km != null && (
          <div className="rpc-detail"><FiMapPin /> {included_km} KM</div>
        )}
        {included_hours > 0 && (
          <div className="rpc-detail"><FiClock /> {included_hours} hrs</div>
        )}
        {extra_km_price != null && (
          <div className="rpc-detail">
            <FiTrendingUp /> Extra KM {formatCurrency(extra_km_price)}
          </div>
        )}
        {extra_hour_price > 0 && (
          <div className="rpc-detail">
            <FiClock /> Extra hr {formatCurrency(extra_hour_price)}
          </div>
        )}
      </div>

      <button
        className="rpc-cta"
        disabled={!status}
        aria-pressed={selected}
        onClick={() => status && onSelect?.(pkg)}
      >
        {!status ? 'Unavailable' : selected ? 'Selected' : 'Select Package'}
      </button>
    </div>
  );
};

export default RentalPackageCard;